import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AuroraBackground } from './ui/aurora-background';
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import logoImage from "../assets/i-can-pitch-logo.jpg"

const Login: React.FC = () => {
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { signInWithGoogle } = useAuth();

    const handleGoogleSignIn = async () => {
        try {
            await signInWithGoogle();
            // Remove navigation since it's handled by backend redirect
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <AuroraBackground>
            <div className="min-h-[calc(100vh-16rem)] flex items-center justify-center px-4 relative z-10">
                <div className="bg-white/80 dark:bg-zinc-900/80 backdrop-blur-lg p-8 rounded-xl shadow-lg w-full max-w-md">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                            Welcome to ICanPitch
                        </h1>
                        <div className="flex justify-center my-4">
                            <img src={logoImage} alt="ICanPitch Logo" className="h-24 w-auto" />
                        </div>
                        <p className="text-gray-600 dark:text-gray-300 mt-2">
                        Perfect your fundraising strategy with confidence. Transform your startup story into a compelling investment opportunity.
                        </p>
                    </div>

                    {error && (
                        <div className="mb-6 p-4 rounded-lg bg-destructive/15 text-destructive">
                            {error}
                        </div>
                    )}

                    <div className="flex flex-col items-center justify-center space-y-6">
                        <div className="w-full max-w-xs">
                            <Button
                                type="button"
                                variant="outline"
                                className="w-full py-6 flex items-center justify-center gap-3 text-base"
                                onClick={handleGoogleSignIn}
                            >
                                <svg className="w-6 h-6" viewBox="0 0 24 24">
                                    <path
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                        fill="#4285F4"
                                    />
                                    <path
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                        fill="#34A853"
                                    />
                                    <path
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                        fill="#FBBC05"
                                    />
                                    <path
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                        fill="#EA4335"
                                    />
                                </svg>
                                Sign in with Google
                            </Button>
                        </div>
                        
                        <div className="text-center mt-6">
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                By signing in, you agree to our{' '}
                                <Link to="/terms" className="text-blue-600 hover:text-blue-800">
                                    Terms of Service
                                </Link>{' '}
                                and{' '}
                                <Link to="/privacy" className="text-blue-600 hover:text-blue-800">
                                    Privacy Policy
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </AuroraBackground>
    );
};

export default Login;
